const items = [
  {
    icon: "ri-focus-3-line",
    title: "Missão",
    text: "Definir com ética, comprometimento e honestidade as soluções tecnológicas que auxiliem nossos clientes nos processos de inovação, sustentabilidade e crescimento.",
    delay: "0ms",
  },
  {
    icon: "ri-eye-line",
    title: "Visão",
    text: "Ser reconhecida no mercado brasileiro como uma das empresas especializadas em inovação, agilidade e desenvolvimento de processos de transformação digital.",
    delay: "80ms",
  },
  {
    icon: "ri-heart-line",
    title: "Valores",
    text: "Ética, eficiência, inovação, honestidade, transparência, comprometimento, respeito às pessoas e foco no sucesso do cliente em tudo que fazemos.",
    delay: "160ms",
  },
];

export default function MissionSection() {
  return (
    <section className="py-20 bg-[#000000]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#62A9E0' }}>
            <div className="w-6 h-px" style={{ background: 'linear-gradient(to right, #62A9E0, #4C86C2)' }}></div>
            Nossa Essência
            <div className="w-6 h-px" style={{ background: 'linear-gradient(to right, #62A9E0, #4C86C2)' }}></div>
          </div>
          <h2 className="text-4xl font-black text-white">O que nos <span className="solus-gradient-text">guia</span></h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((item) => (
            <div
              key={item.title}
              className="rounded-lg p-8 hover:translate-y-[-4px] transition-transform duration-300 group"
              style={{
                background: 'rgba(255,255,255,0.03)',
                border: '1px solid rgba(98,169,224,0.2)',
              }}
            >
              {/* Icon */}
              <div
                className="w-12 h-12 flex items-center justify-center rounded-lg mb-6 solus-gradient-diag"
              >
                <i className={`${item.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{item.title}</h3>
              <p className="text-white/55 text-sm leading-relaxed">{item.text}</p>

              {/* Bottom accent line */}
              <div
                className="mt-6 h-px opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ background: 'linear-gradient(to right, #62A9E0, #4C86C2)' }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
